import axios, { AxiosResponse } from 'axios';

export enum EStavLei {
    ISSUED = 'ISSUED',
    LAPSED = 'LAPSED',
    RETIRED = 'RETIRED',
    ANNULLED = 'ANNULLED',
    DUPLICATE = 'DUPLICATE'
}

export enum EEntityCategory {
    GENERAL = 'GENERAL',
    FUND = 'FUND',
    BRANCH = 'BRANCH',
    SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
    RESIDENT_GOVERNMENT_ENTITY = 'RESIDENT_GOVERNMENT_ENTITY',
    INTERNATIONAL_ORGANIZATIO = 'INTERNATIONAL_ORGANIZATIO'
}

export interface ILeiItem {
    oid: number;
    lei: string;
    legalname: string;
    registauthorityentityid: string;
    entitystatus: 'ACTIVE' | 'INACTIVE';
    registrationstatus: EStavLei;
    lastupdatedate: string;
}

export interface ILeiPrehled {
    offset: number;
    limit: number;
    count: number;
    order: string;
    seznamlei: ILeiItem[];
}

export interface ILeiDetail {
    entity: {
        oid?: number;
        lei: string;
        legalname: string;
        translitotherentityname: string;
        headquartersaddress: {
            firstaddressline: string;
            city: string;
            country: string;
            postalCode: string;
        };
        registrationauthorityid: string;
        otherregistauthorityid?: string;
        registauthorityentityid: string;
        legaljurisdiction: string;
        entitycategory: EEntityCategory[];
        entitylegalformcode: string;
        otherlegalform?: string;
        entitystatus: string;
        entitycreationdate: string;
    };
    registration: {
        initialregistrationdate: string;
        lastupdatedate: string;
        registrationstatus: EStavLei;
        nextrenewaldate: string;
        managinglou: string;
    };
    releationship: {
        startnodeid: string;
        endnodeid: string;
        relationshiptype: string;
        relationshipstatus: string;
        registrationstatus: string;
    }[];
    exceptions: {
        lei: string;
        exceptioncategory: string;
        exceptionreason: string;
    }[];
    datelastloaded: string;
}

export interface ILeiPrehledInput {
    offset: number;
    limit: number;
    order: string;
    lei?: string;
    regauthentityid?: string;
    legalname?: string;
}

const leiUctyApi = (params: ILeiPrehledInput) => {
    return axios({
        method: 'GET',
        url: `https://${window.location.hostname}/isbpublicjson/api/LegalEntity`,
        params: params
    }).then((resp: AxiosResponse<ILeiPrehled>) => resp.data);
};

export const leiDetailApi = (id: string | number) => {
    return axios({
        method: 'GET',
        url: `https://${window.location.hostname}/isbpublicjson/api/LegalEntity/${id}`
    }).then((resp: AxiosResponse<ILeiDetail>) => resp.data);
};

export default leiUctyApi;
